// MixPanelContext.tsx
"use client";

import React, { createContext, useContext, useEffect, useState } from "react";
import mixpanel from "mixpanel-browser";
import { useAppContext } from "@thriwe-2-0/thriwe-ui-utils";

interface MixPanelContextProps {
  trackEvent: (label: string, payload?: object) => void;
  mixpanelInitialized: boolean;
}

const MixPanelContext = createContext<MixPanelContextProps | undefined>(
  undefined
);

export const MixPanelProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [mixpanelInitialized, setMixpanelInitialized] = useState(false);
  const {
    state: { user },
  } = useAppContext();
  useEffect(() => {
    if (
      !mixpanelInitialized &&
      // process.env.NEXT_PUBLIC_ENV === "PRODUCTION" &&
      process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN
    ) {
      mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN);
      setMixpanelInitialized(true);
    }
  }, [mixpanelInitialized]);

  const trackEvent = (label: string, payload: object = {}) => {
    if (mixpanelInitialized) {
      try {
        mixpanel.track(`${label}`, {
          userId: user?.data?.userId ?? "",
          ...payload,
        });
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <MixPanelContext.Provider value={{ trackEvent, mixpanelInitialized }}>
      {children}
    </MixPanelContext.Provider>
  );
};

export const useMixPanel = () => {
  const context = useContext(MixPanelContext);
  if (!context) {
    throw new Error("useMixPanel must be used within a MixPanelProvider");
  }
  return context;
};
